import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';
import type { AnalyticsKeyLocation } from '../../services/api';

interface LocationsTabProps {
  data?: AnalyticsKeyLocation[];
}

const LocationsTab: React.FC<LocationsTabProps> = ({ data }) => {
  const chartData = data && data.length > 0
    ? data.map(item => ({
      city: item.city,
      usage: item.count
    }))
    : [];

  if (chartData.length === 0) {
    return (
      <div className="tab-content">
        <div className="no-data-message">
          <p>No location usage data available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tab-content">
      <div className="chart-container">
        <h3 className="chart-title">Usage by Location (Top Cities)</h3>
        <div className="chart-wrapper">
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" vertical={false} />
              <XAxis
                dataKey="city"
                tick={{ fontSize: 12, fill: '#64748b' }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                tick={{ fontSize: 12, fill: '#64748b' }}
                axisLine={false}
                tickLine={false}
                tickFormatter={(value: number) => value.toLocaleString()}
              />
              <Tooltip
                cursor={{ fill: '#f8fafc' }}
                contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
              />
              <Bar
                dataKey="usage"
                fill="#ff6b35"
                radius={[4, 4, 0, 0]}
                maxBarSize={60}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default LocationsTab;
